<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="cardOptionsWithCSVExportOption"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <v-row
      class="custom-line-chart-container"
      justify="center"
    >
      <slot />
      <HighCharts
        v-if="series.length"
        :ref="chartRef"
        class="custom-line-chart"
        :options="chartOptions"
      />
    </v-row>
  </CardWithTitle>
</template>

<script>
import { Chart } from 'highcharts-vue';
import highChartsBasics from '@/mixins/highcharts-basics';
import exportModel from '@/mixins/export-model';
import cardsModel from '@/mixins/cards-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import merge from 'lodash/merge';

export default {
  name: 'CustomLineChart',
  components: {
    HighCharts: Chart,
    CardWithTitle,
  },
  mixins: [
    highChartsBasics,
    cardsModel,
    exportModel,
  ],
  props: {
    requestStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    series: {
      type: [Array, Object],
      default: () => ([]),
    },
    categories: {
      type: Array,
      default: () => ([]),
    },
    cardOptions: {
      type: [Array, Object],
      default: () => ([]),
    },
    showGranularity: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      granularity: null,
    };
  },
  computed: {
    chartOptions() {
      const customOptions = {
        chart: {
          type: 'line',
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
        },
        plotOptions: {
          line: {
            borderWidth: 0.5,
          },
        },
        tooltip: {
          shared: true,
          xDateFormat: this.xDateFormat,
        },
        xAxis: {
          lineWidth: 0,
          tickLength: 0,
          type: this.typeXAxios,
          title: null,
          labels: {
            format: this.labelFormat,
          },
        },
        yAxis: {
          gridLineWidth: 0,
          title: this.$t('components.models.CustomLineChart.label.yAxisTitle'),
        },
        series: this.series,
      };

      return merge({}, this.highchartsBasics, this.highchartTheme, customOptions, this.cardOptions);
    },
  },
};
</script>

<style scoped lang="scss">
  .custom-line-chart-container {
    height: 100%;
    width: 100%;
    margin: 0;
  }

  .custom-line-chart {
    height: 100%;
    width: 100%;
    padding: 15px 15px 0 15px;
    overflow: visible !important;
  }
</style>
